import { FaBlog, FaReplyAll, FaUsers } from "react-icons/fa";
import {
  MdOutlineAddHome,
  MdOutlinePermMedia,
  MdPolicy,
  MdQueryStats,
  MdOutlineUploadFile,
} from "react-icons/md";

export const base_url_2 = `${process.env.REACT_APP_BASE_URL || "https://dev.websiteadmin.insugo.in"}/api/`;

export const base_url = base_url_2 + "insugo/";
// export const base_url = "https://digi.pmpframe.com/api/insugo/";

// blog,media,testimonial,career,associate,queries

export const SideBarItems = [
  {
    path: "/digi",
    icon: MdQueryStats,
    label: "Queries",
    status: true,
    value: "queries",
  },
  { path: "/digi/blog", icon: FaBlog, label: "Blog", status: true, value: "blog" },
  {
    path: "/digi/testimonial",
    icon: FaReplyAll,
    label: "Testimonial",
    status: true,
    value: "testimonial",
  },
  {
    path: "/digi/media",
    icon: MdOutlinePermMedia,
    label: "Media",
    status: true,
    value: "media",
  },
  {
    path: "/digi/associated",
    icon: MdOutlineAddHome,
    label: "Associated",
    status: true,
    value: "associate",
  },
  {
    path: "/digi/careers",
    icon: FaReplyAll,
    label: "Careers",
    status: true,
    value: "career",
  },
  {
    path: "/digi/policy",
    icon: MdPolicy,
    label: "Policy",
    status: true,
    value: "policy",
  },
  { path: "/digi/users", icon: FaUsers, label: "Users", status: false },
  {
    path: "/digi/big-files",
    icon: MdOutlineUploadFile,
    label: "Big File Upload",
    status: true,
    value: "big-files",
  },
];
